import { render, staticRenderFns } from "./suitch-bridge-widget.vue?vue&type=template&id=5989c9a5&scoped=true&"
import script from "./suitch-bridge-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-bridge-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-bridge-widget.vue?vue&type=style&index=0&id=5989c9a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989c9a5",
  null
  
)

export default component.exports